import React from 'react';
import './App.scss';
import { BrowserRouter } from 'react-router-dom';
import Layout from './pages/layout/layout';
import Loader from './components/loader/loader';
import { constants } from './constants';

function App() {
    return (
        <div className="App h-100">
            <Loader />
            <BrowserRouter basename={constants.SH_PORTAL_BASENAME}>
                <Layout />
            </BrowserRouter>
        </div>
    );
}

export default App;
